import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './i18n/config'
import { createAnalyticsTracker } from './utils/analytics.ts'

import { ErrorBoundary } from './components/common/ErrorBoundary'

// Initialize analytics tracking
const analytics = createAnalyticsTracker({
  apiBaseUrl: import.meta.env.VITE_ANALYTICS_ENDPOINT || 'https://techunity-ghbh.onrender.com/api',
  enabled: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
  debug: import.meta.env.DEV === true
});

// Make analytics available globally
(window as any).analytics = analytics;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
